.wrapper {
  border-radius: 3px;
  border: 1px solid var(--border-default);
  padding: var(--spacing-md) var(--spacing-lg);
  text-align: left;
}

.list {
  margin-top: var(--spacing-sm);
  line-height: 22px;
  color: var(--text-tertiary);
}

.listItemDefault,
.listItemValid {
  margin-bottom: var(--spacing-xs);
  margin-left: var(--spacing-sm);
}

.listItemDefault {
  color: var(--text-default);
}
.listItemDefault::before {
  content: "\2022";
  display: inline-block;
  position: relative;
  left: -4px;
  width: 10px;
}

.listItemValid {
  color: var(--notification-success) !important;
}
.listItemValid::before {
  content: "\2713";
  display: inline-block;
  position: relative;
  left: -8px;
  width: 10px;
}

.ruleText {
  margin-left: var(--spacing-sm);
  color: inherit !important;
}
